import React, { useContext, useState, useEffect } from "react";
import "../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import ColorsMain from "../../colors/ColorsMain";
import { GLOBAL_LANGUAGE } from "../../language/language";
import Logo from "../../assets/logos/LogoColurs.png";
import { UtilContext } from "../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../components/button/ButtonWhite";
import NavbarRegistro from "../../components/navbar/NavbarRegistro";
import ActivityCompany from "../../components/layouts/bienvenida/ActivityCompany";
import ServiceColurs from "../../components/layouts/bienvenida/ServiceColurs";

import NameCompany from "../../components/layouts/bienvenida/NameCompany";
import Welcome from "../../components/layouts/bienvenida/Welcome";
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { motion } from 'framer-motion';



const Welcomee = (props) => {
  const { logout } = useContext(AuthContext);

  const navigate = useNavigate();

  const location = useLocation();
  const DetailUser = JSON.parse(localStorage.getItem('userDetails'));


  const [errorMesagge, setErrorMesagge] = useState(false)
  const [layout, setLayout] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [activityFinal, setActivityFinal] = useState([])
  const [ServiceColursFinal, setServiceColursFinal] = useState([])

  const transitionNext = { x: "-100%", opacity: 0 }
  const animateNext = { x: 0, opacity: 1 }
  const durationNext = { duration: 1, ease: "easeOut" }

  const [activity, setActivity] = useState([
    {
      "id": 1,
      "actividad": "Ganadería",
      "status": false
    },
    {
      "id": 2,
      "actividad": "Minería y Extracción",
      "status": false
    },
    {
      "id": 3,
      "actividad": "Entretenimiento y Juegos de Azar",
      "status": false
    },
    {
      "id": 4,
      "actividad": "Comercio de Bienes de Lujo y Real Estate",
      "status": false
    },
    {
      "id": 5,
      "actividad": "Producción de Contenidos y Cursos Online",
      "status": false
    },
    {
      "id": 6,
      "actividad": "Ninguna de los anteriores",
      "status": false
    }
  ]
  );
  const [serviceColurs, setServiceColurs] = useState([
    {
      "id": 1,
      "actividad": "Transferencias Internacionales",
      "status": false
    },
    {
      "id": 2,
      "actividad": "Pagos Globales",
      "status": false
    },
    {
      "id": 3,
      "actividad": "Intercambio de Divisas",
      "status": false
    },
    {
      "id": 4,
      "actividad": "Recaudo Internacional",
      "status": false
    },
    {
      "id": 5,
      "actividad": "Payroll",
      "status": false
    },
    {
      "id": 6,
      "actividad": "Monetización",
      "status": false
    }
  ]
  );
  const toggleStatus = (id) => {
    const updatedActivities = activity.map((activity) => {
      // Si se selecciona "Ninguna de los anteriores"
      if (id === 6) {
        return { ...activity, status: true }; // Activa "Ninguna de los anteriores"
      }
      // Si se selecciona una actividad específica
      else if (activity.id === id) {
        return { ...activity, status: !activity.status }; // Invierte el estado de la actividad seleccionada
      }

      // Si "Ninguna de los anteriores" está activa y se selecciona otra actividad
      if (activity.id === 6 && activity.status) {
        return { ...activity, status: false }; // Desactiva "Ninguna de los anteriores"
      }

      return activity; // Mantiene el estado de las demás actividades
    });

    // Si "Ninguna de los anteriores" está activada, asegúrate de que las otras estén desactivadas
    if (updatedActivities.find(activity => activity.id === 6 && activity.status)) {
      updatedActivities.forEach(activity => {
        if (activity.id !== 6) {
          activity.status = false; // Desactiva todas las demás
        }
      });
    }

    // Nueva variable que guarda solo los elementos con status true
    const activeActivities = updatedActivities.filter(activity => activity.status);

    // Actualiza el estado de actividades
    setActivity(updatedActivities);

    // Si necesitas usar activeActivities en otro lado, puedes hacer algo con él aquí
    setActivityFinal(activeActivities);
  };



  const toggleStatusServiceColurs = (id) => {
    const updatedActivities = serviceColurs.map((serviceColurs) => {
      // Invierte el estado de la actividad seleccionada sin ninguna restricción adicional
      if (serviceColurs.id === id) {
        return { ...serviceColurs, status: !serviceColurs.status };
      }
      return serviceColurs; // Mantiene el estado de las demás actividades sin cambios
    });

    // Filtra solo las actividades con `status: true`
    const activeActivities = updatedActivities.filter(serviceColurs => serviceColurs.status);

    // Actualiza el estado de actividades
    setServiceColurs(updatedActivities);

    // Puedes usar `activeActivities` para hacer algo con las actividades activas
    setServiceColursFinal(activeActivities);
  };



  const navegar = () => {
    if (companyName != "" && activityFinal != "" && ServiceColursFinal != "") {

      const data = {
        companyName: companyName,
        activityFinal: activityFinal,
        ServiceColursFinal: ServiceColursFinal
      };

      // Convertir el objeto a JSON y almacenarlo en el localStorage
      localStorage.setItem("companyData", JSON.stringify(data));
      navigate("/splash-documentos", { state: { companyName: companyName, activityFinal: activityFinal, ServiceColursFinal: ServiceColursFinal } })

    } else {
      setErrorMesagge(true)
    }
  }

  const navegarServiceColurs = () => {
    if (ServiceColursFinal != "") {
      console.log("ServiceColursFinal", ServiceColursFinal);

      setErrorMesagge(false)
      setLayout(4)

    } else {
      setErrorMesagge(true)
    }

  }
  const navegarActivityCompany = () => {
    if (companyName != "") {
      setErrorMesagge(false)
      setLayout(3)

    } else {
      setErrorMesagge(true)
    }

  }
  useEffect(() => {
    setErrorMesagge(false)

  }, [companyName]);

  useEffect(() => {

    console.log("DetailUser", DetailUser);
    if (DetailUser.document_status === "APPROVED") {

      navigate("/splash", { state: { DetailUser: DetailUser } })
    }
    if (DetailUser.document_status !== "INITIAL") {

      navigate("/splash", { state: { DetailUser: DetailUser } })
    }
  }, [])


  return (
    <div>
      <div className=" py-5 px-4 md:px-11 bg-[#1B1B22] ">
        <NavbarRegistro onClose={logout} />
      </div>
      <div className="welcome flex items-center justify-center flex-col px-4 md:px-24 pt-6 md:pt-10 pb-20 md:pb-44">
        <div
          style={{ color: ColorsMain.texttMain }}
          className="flex justify-evenly flex-col gap-2 w-full md:w-[550px]"
        >
          <img src={Logo} style={{ width: 32, height: 32 }}></img>
          <div className="flex flex-col">
            {layout === 1 &&
              <motion.div
                initial={transitionNext}
                animate={animateNext}
                transition={durationNext}
              >
                <Welcome onClick={() => setLayout(2)} name={`${DetailUser?.first_name} ${DetailUser?.last_name}`} />
              </motion.div>}
            {layout === 2 &&
              <motion.div
                initial={transitionNext}
                animate={animateNext}
                transition={durationNext}
              >
                <NameCompany onClick={() => navegarActivityCompany()} setCompanyName={setCompanyName} errorMesagge={errorMesagge} companyName={companyName} />
              </motion.div>}
            {layout === 3 &&
              <motion.div
                initial={transitionNext}
                animate={animateNext}
                transition={durationNext}
              >
                <ServiceColurs onClick={() => navegarServiceColurs()} toggleStatus={toggleStatusServiceColurs} errorMesagge={errorMesagge} activity={serviceColurs} />
              </motion.div>}
            {layout === 4 &&
              <motion.div
                initial={transitionNext}
                animate={animateNext}
                transition={durationNext}
              >
                <ActivityCompany onClick={() => navegar()} toggleStatus={toggleStatus} errorMesagge={errorMesagge} activity={activity} />
              </motion.div>}

          </div>
        </div>
      </div>
    </div >
  );
};

export default Welcomee;
